import React from 'react';
import { Grid, IconButton, TableBody, TableCell, TableHead, TableRow, TextField, Typography, withStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/Delete';

import Table from '../components/Table/Table';

const styles = (theme) => ({});

class FiguresUploadForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tempArr: [],
      //   setOfFigures: 1,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.setOfFigures !== prevState.setOfFigures) {
      let buff = [];
      for (let i = 0; i < nextProps.setOfFigures; i++) {
        buff.push(i + 1);
      }
      return { setOfFigures: nextProps.setOfFigures, tempArr: buff };
    } else {
      return null;
    }
  }

  handleChange(event, type) {
    this.props.handleFigureMemo(event, type);
  }

  render() {
    const { setOfFigures } = this.props;
    const { tempArr } = this.state;
    console.log(this.props.figures, 'figures');
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2} style={{ color: '#555', fontWeight: 500 }}>
              <Typography style={{ fontWeight: 'bold' }}>
                * For International Trainee registration(UAE), Document for proof of Resident Attachment is required.
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {setOfFigures &&
            tempArr.map((item, idx) => {
              return (
                <TableRow key={`figures-row-${idx + 1}`}>
                  <TableCell component="th" width="30%" style={{ color: '#555', textAlign: 'center' }}>
                    {/* Figure {idx + 1} */}
                    Document for proof of Resident
                    <br />
                    (Format: JPG, GIF, PNG)
                  </TableCell>
                  <TableCell component="td" width="70%">
                    <Grid container spacing={1}>
                      <Grid item container spacing={1} alignItems="center">
                        <Grid item xs={10}>
                          <input
                            type="file"
                            id={`img-picker-${idx}`}
                            accept="image/png, image/jpeg, image/gif, image/jpg,"
                            style={{ display: 'none' }}
                            onChange={(e) => this.props.handleChangeImg(e, idx)}
                          />
                          <TextField
                            id={`figure-img-${idx}`}
                            variant="outlined"
                            fullWidth
                            size={'small'}
                            placeholder={'Select file'}
                            value={this.props.figures[idx] && this.props.figures[idx].name ? this.props.figures[idx].name : ''}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: 'center' }}>
                          <IconButton
                            // color={'primary'}
                            onClick={(e) => this.props.clickUploadImg(e, `img-picker-${idx}`)}
                            size={'small'}
                            style={{
                              backgroundColor: this.props.theme.palette.primary.main,
                              borderRadius: '4px',
                              color: '#fff',
                              width: '100%',
                              //   padding: this.props.mode === 'modify' ? this.props.theme.spacing(1, 1.2) : this.props.theme.spacing(1, 1.5),
                            }}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: 'center' }}>
                          <IconButton
                            // color={'primary'}
                            onClick={(e) => this.props.deleteImg(idx, this.props.figures[idx])}
                            disabled={!this.props.figures[idx] || this.props.figures[idx] === ''}
                            size={'small'}
                            style={{
                              width: '100%',
                              backgroundColor:
                                !this.props.figures[idx] || this.props.figures[idx] === '' ? 'gray' : this.props.theme.palette.primary.main,
                              color: '#fff',
                              borderRadius: '4px',
                              //   padding: this.props.mode === 'modify' ? this.props.theme.spacing(1, 1.2) : this.props.theme.spacing(1, 1.5),
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      {/* <Grid item container>
                        <TextField
                          id={`figure-img-content-${idx}`}
                          variant="outlined"
                          fullWidth
                          size={'small'}
                          placeholder={'Type content about figure.'}
                          onChange={(e) => this.props.handleFigureMemo(e, idx)}
                          value={this.props.figuresMemo && this.props.figuresMemo[idx]}
                          disabled={!this.props.figures[idx] || this.props.figures[idx] === '' ? true : false}
                        />
                      </Grid> */}
                    </Grid>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FiguresUploadForm);
